import React, { useState } from 'react';
import { Box } from '@common-fe/common-fe';
import styled from 'styled-components';

import { IEmployerCalendarEventDtoCategoryEnum } from '@/dtos';

import EventTypeDropdown from './EmployerCalendarEvents/EventTypeDropdown';
import EmployerCalendar from './EmployerCalendar';
import EmployerCalendarEvents from './EmployerCalendarEvents';
import { useEmployerCalendarEvents } from './hooks';

const Wrapper = styled(Box)`
  flex-direction: row;
  & > *:not(:last-child) {
    display: block;
    margin-right: 12px;
  }

  @media (min-width: 320px) {
    flex-direction: column;
  }

  @media (min-width: 1200px) {
    flex-direction: row;
  }
`;

const EmployerCalendarDashboard = () => {
  const [currentType, setCurrentType] = useState<IEmployerCalendarEventDtoCategoryEnum | null>(null);

  const {
    isError,
    isEmpty,
    isLoading,
    currentEvents,
    selectedDate,
    setSelectedDate,
    dataMap,
    currentMonth,
    setCurrentMonth,
    handleResetSelectedDate,
  } = useEmployerCalendarEvents({
    currentType,
  });

  return (
    <>
      <Wrapper
        data-testid="employer-calendar-dashboard"
        align="stretch"
        pad="spacing24"
        background="module"
        round="moduleRound"
        gap="spacing24"
      >
        <div data-testid="employer-calendar-dashboard_calendar-wrapper">
          <EmployerCalendar
            selectedDate={selectedDate}
            onSelectDate={setSelectedDate}
            datesMap={dataMap}
            currentMonth={currentMonth}
            onChangeCurrentMonth={setCurrentMonth}
          />
        </div>

        <EmployerCalendarEvents
          events={currentEvents}
          isLoading={isLoading}
          isErrorPlaceholder={isError}
          currentMonth={currentMonth}
          selectedDate={selectedDate}
          isEmpty={isEmpty}
          onResetSelectedDate={handleResetSelectedDate}
        >
          <EventTypeDropdown disabled={isEmpty} value={currentType} onChangeValue={setCurrentType} />
        </EmployerCalendarEvents>
      </Wrapper>
    </>
  );
};
export default EmployerCalendarDashboard;
